<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.27</b> - Performance improvements, new weapon prefix, Caverns view
      panning, and much more!
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Added a tutorial for new players</li>
      <li>The Caverns view is now pannable by click+dragging</li>
      <li>Added new weapon prefix "Gladiator's" - 20% chance to stun.</li>
      <li>
        Added mod commands to silence misbehaving players; deputized Mr. Gentle, Trevor,
        Draquonis2019, and Meisterlampe as mods.
      </li>
      <li>Audio will now be muted when tabbing out / minimizing the game.</li>
      <li>Pixie Dust store appeal for wishlists is now an appeal for reviews</li>
      <li>
        Performance improvements
        <ul>
          <li>- Dead body debris now disappears after 60 seconds</li>
          <li>- Fixed a (bad) memory leak on the Edit Hero screen</li>
          <li>- Did an optimization to the peanuts animation</li>
          <li>- Fixed a caverns memory leak</li>
          <li>- Did an optimization to the blessed rendering</li>
        </ul>
      </li>
    </ul>
  </div>
</template>
